import React from "react";
import { Flex, Spinner, Text } from "@chakra-ui/react";

export default function Loader({ text = "Loading..." }) {
  return (
    <Flex
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      zIndex={9999}
      backgroundColor="rgba(255, 255, 255, 0.8)"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      gap={4}
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="brand.500"
        size="xl"
      />
      <Text color="gray.600" fontSize="lg" fontWeight="medium">
        {text}
      </Text>
    </Flex>
  );
}